import { render, staticRenderFns } from "./UploadRevenuePage.vue?vue&type=template&id=af485830"
import script from "./UploadRevenuePage.vue?vue&type=script&lang=js"
export * from "./UploadRevenuePage.vue?vue&type=script&lang=js"
import style0 from "./UploadRevenuePage.vue?vue&type=style&index=0&id=af485830&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports